import { NgClass, NgComponentOutlet, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { App } from '@df/core/app';
import { AdvancedCommerceListingFiltersComponentDef, AdvancedCommerceStore } from '@df/module-advanced-commerce';
import { DfUiModule } from '@df/ui/df-ui.module';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import flatten from 'lodash-es/flatten';
import { ICmsOutletBlockComponent } from '../../../catalog/outlet-block/icms-outlet-block.component';
import { toggleTieredPriceModeListingEvent } from '../../../catalog/ui/listing/product-listing-tools.component';
import { NListing } from '../../../catalog/ui/listing/product-listing.interface';
import { IfTradeStoreDirective } from '../../../multisite/trade/if-trade-store.directive';
import { TradeClassDirective } from '../../../multisite/trade/trade-class.directive';
import { NAdvancedCommerceListingFiltersModal } from './filter/advanced-commerce-filter-modal.component';
import { AdvancedCommerceListingSizeComponent } from './size/advanced-commerce-listing-size.component';
import { AdvancedCommerceProductListingSortComponent } from './sort/advanced-commerce-advanced-commerce-product-listing-sort.component';

export interface IAcFilterSelectedOption {
    filterType: 'ac-filter';
    label: string;
    value: string | number;
    matchesCount: number;
    unselect: (filter: AdvancedCommerceStore.Filters.Filter, option: AdvancedCommerceStore.Filters.Option) => void;
    filterProp: AdvancedCommerceStore.Filters.Filter;
    optionProp: AdvancedCommerceStore.Filters.Option;
}

@Component({
    selector: 'ac-product-listing-tools',
    templateUrl: '../../../catalog/ui/listing/product-listing-tools.html',
    standalone: true,
    imports: [
        DfUiModule,
        ICmsOutletBlockComponent,
        IfTradeStoreDirective,
        NgClass,
        NgComponentOutlet,
        NgIf,
        NgSwitch,
        NgSwitchCase,
        NgSwitchDefault,
        NgTemplateOutlet,
        PriceComponent,
        TradeClassDirective,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedCommerceListingToolsComponent
    extends AdvancedCommerceListingFiltersComponentDef
    implements OnInit, NListing.ILisitngTotals
{
    @Input()
    type: 'bulkOrder' | 'plp' = 'plp';
    @Output()
    tieredPriceModeChange = new EventEmitter();

    private _tieredPrice = true;

    readonly DfModalService: DfModalService | undefined = inject(DfModalService);
    readonly app = inject(App);
    ngOnInit() {
        this.toggleTieredPriceMode(true);
        //   this.timeoutService?.setTimeout(() => this.onListingUpdate(), 0);
    }
    showFiltersModal(): void {
        this.DfModalService?.open(undefined, NAdvancedCommerceListingFiltersModal.id, undefined);
    }
    get noResults(): boolean {
        return this.store.total() === 0;
    }
    get tieredPrice(): boolean {
        return !!this._tieredPrice;
    }
    set tieredPrice(value: boolean) {
        this._tieredPrice = value;
        this.toggleTieredPriceMode(value);
        this.changeDetectorRef.detectChanges();
    }
    private toggleTieredPriceMode(value: boolean): void {
        this.app.events.broadcast(toggleTieredPriceModeListingEvent, value);
        this.tieredPriceModeChange.emit(value);
    }
    get getTotal(): number {
        return this.store.metaCount();
    }
    get sortOutlet(): NListing.IOutlet {
        return { component: AdvancedCommerceProductListingSortComponent, inputs: { sort: true } };
    }
    get sizeOutlet(): NListing.IOutlet {
        return { component: AdvancedCommerceListingSizeComponent, inputs: { size: true } };
    }
    get bulkOrderSortOutlet(): NListing.IOutlet {
        return { component: AdvancedCommerceProductListingSortComponent, inputs: { sort: true } };
    }
    get filtersWithSelection(): IAcFilterSelectedOption[] | undefined {
        return flatten(
            this.store.filtersWithSelection().map(filter =>
                filter.options
                    ?.filter(option => option.selected)
                    .map(
                        option =>
                            ({
                                filterType: 'ac-filter',
                                label: filter.label,
                                value: option.label,
                                matchesCount: option.count || 0,
                                unselect: (filter: AdvancedCommerceStore.Filters.Filter, option: AdvancedCommerceStore.Filters.Option) => {
                                    this.store.filtersOptionUnselect(filter, option);
                                },
                                filterProp: filter,
                                optionProp: option
                            }) as IAcFilterSelectedOption
                    )
            )
        ).filter(Boolean) as IAcFilterSelectedOption[];
    }
}
